import React from 'react';

const ContactSection = () => {
  return (
    <section id="contacts" className="w-full bg-gray-100 py-16 px-4">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
        {/* Карта */}
        <div className="w-full h-[400px]">
          <iframe
            title="map"
            src="https://yandex.ru/map-widget/v1/?um=constructor%3Afc3f2d1a9a8d8bc58f36ea122ed2aa9e85a3a4b2372c2a6dd8232a2532a8ac4e&amp;source=constructor&l=map&z=9&pt=37.220948,55.527260"
            width="100%"
            height="100%"
            frameBorder="0"
            className="rounded-2xl shadow-lg"
          ></iframe>
        </div>

        {/* Контакты */}
        <div className="bg-white rounded-2xl shadow-xl p-8 space-y-6">
          <h3 className="text-3xl font-bold text-gray-800">Контактная информация</h3>
          <div className="space-y-3 text-gray-700">
            <p><strong>Адрес:</strong> Центральная ул., 15А, стр. 4</p>
            <p><strong>Телефон:</strong> +7 (967) 160-22-66</p>
            <p><strong>Email:</strong> serejazork@gmail.com</p>
            <p><strong>Время работы:</strong> Пн-Вс, 8:00 — 20:00</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
